import React from "react";
import logo from "../../images/logo.svg";
import "./cp.scss";
import { MdOutlineMailOutline } from "react-icons/md";
import { MdOutlineLocalPhone } from "react-icons/md";
import { RiHome2Line } from "react-icons/ri";
import Swal from "sweetalert2";
import { BASE } from "../../App";
import axios from "axios";

const ContactPage = () => {
  const [contactInfo, setContactInfo] = React.useState({
    full_name: "",
    email: "",
    message: "",
    phone_number: "",
    interest: "Import Finance",
  });

  const [err, setError] = React.useState({});

  const handleChange = (e) => {
    setContactInfo({ ...contactInfo, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError({});
    // Handle form submission logic here
    try {
      const res = await axios.post(BASE + "/api/contact-inquiry/", contactInfo);
      if (res.status) {
        Swal.fire({
          title: "Message Sent!",
          text: "Thank you for contacting us. We will get back to you shortly.",
          icon: "success",
          confirmButtonText: "OK",
        });
        setContactInfo({
          full_name: "",
          email: "",
          message: "",
          phone_number: "",
          interest: "Import Finance",
        });
      }
    } catch (error) {
      setError(error.response.data);
      console.log(error);
    }
  };
  return (
    <div className="cp_container">
      <div className="cp_back_top">
        <div className="cp_left_title">
          <h1>Contact Us</h1>
          <h3>Connect with TradeFlair Trade Finance Experts</h3>
          <p>
            At TradeFlair, we assist businesses with reliable trade finance
            solutions and execution support. Contact our team to discuss import
            finance, export finance, LC-based solutions, and partnership
            opportunities tailored to your business requirements.
          </p>
        </div>
      </div>
      <div className="cp_bottom">
        <div className="cp_left">
          <div className="cp_left_info">
            <p>
              Give us a call or fill out our contact form, and one of our
              TradeFlair team members will be in touch
            </p>

            <div className="cp_info_icons">
              <RiHome2Line color="#356bb3" />
              <p>
                <span>Office timing:</span> 9:00 am - 7:00 pm (Monday -
                Saturday)
              </p>
            </div>
            <div className="email_list">
              <div className="cp_info_icons">
                <MdOutlineLocalPhone color="#356bb3" />
                <span>Phone Number:</span>
              </div>
              <div>
                <p>
                  <a href="tel:+919810911531" target="_blank" rel="noreferrer">
                    {" "}
                    +91 9810911531
                  </a>{" "}
                </p>
                <p>
                  {" "}
                  <a href="tel:+919453703128 " target="_blank" rel="noreferrer">
                    {" "}
                    +91-9453703128{" "}
                  </a>
                </p>
              </div>
            </div>
            <div className="email_list">
              <div className="cp_info_icons">
                <MdOutlineMailOutline color="#356bb3" />
                <span>Email:</span>
              </div>
              <div>
                <p>
                  <a
                    href="mailto:sales@tradeflaircorporate.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    sales@tradeflaircorporate.com
                  </a>{" "}
                </p>
                <p>
                  <a
                    href="mailto:support@tradeflaircorporate.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    support@tradeflaircorporate.com
                  </a>{" "}
                </p>
                <p>
                  <a
                    href="mailto:trade@tradeflaircorporate.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    trade@tradeflaircorporate.com
                  </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="cp_right">
          <div className="cp_form_title">
            <img src={logo} alt="" />
            <h2>Contact Us! </h2>
          </div>
          <form action="">
            <div className={`cp_input_div ${"full_name" in err && "outline_red"}`}>
              <label htmlFor="">Full Name</label>
              <input
                type="text"
                placeholder="Full Name"
                name="full_name"
                value={contactInfo.full_name}
                onChange={handleChange}
              />
            </div>
            <div className={`cp_input_div ${"email" in err && "outline_red"}`}>
              <label htmlFor="">Email address</label>
              <input
                type="text"
                placeholder="Email address"
                name="email"
                value={contactInfo.email}
                onChange={handleChange}
              />
            </div>
            <div className={`cp_input_div ${"phone_number" in err && "outline_red"}`}>
              <label htmlFor="">Phone Number</label>
              <input
                type="text"
                placeholder="Phone Number"
                name="phone_number"
                value={contactInfo.phone_number}
                onChange={handleChange}
              />
            </div>
            <div className="cp_radio">
              <h3>Interested In:</h3>
              <div className="cp_radio_input">
                <input
                  type="radio"
                  name="interest"
                  value="Import Finance"
                  id="import"
                  checked={contactInfo.interest === "Import Finance"}
                  onChange={handleChange}
                ></input>
                <label htmlFor="import">Import Finance</label>
              </div>
              <div className="cp_radio_input">
                <input
                  type="radio"
                  name="interest"
                  value="Export Finance"
                  id="export"
                  checked={contactInfo.interest === "Export Finance"}
                  onChange={handleChange}
                ></input>
                <label htmlFor="export">Export Finance</label>
              </div>
              <div className="cp_radio_input">
                <input
                  type="radio"
                  name="interest"
                  value="Domestic Finance"
                  id="domestic"
                  checked={contactInfo.interest === "Domestic Finance"}
                  onChange={handleChange}
                ></input>
                <label htmlFor="domestic">Domestic Finance</label>
              </div>
            </div>
            <textarea
              name="message"
              value={contactInfo.message}
              onChange={handleChange}
              placeholder="Leave your message here"
              id=""
            ></textarea>
 

            <button onClick={handleSubmit}>Send</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
